import React, { useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Password } from 'primereact/password'
import { persistor } from '../../store'
import TokenService from '../../services/token.service'
import { validators } from '../../utils/helpers/validators'
import { newUserPassword } from '../../slices/auth'
import swalAlert from '../../utils/helpers/swalAlert'
import { pathname } from '../../utils/constants/pathname'
import logo from '../../assets/imgs/logos/logo.svg'
import Button from '../../components/common/buttons'
import './new-user-password.scss'

const NewUserPassword = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [inputs, setInputs] = useState({
    password: '',
    confirmPassword: '',
  })

  const sendNewUserPassword = (password) => dispatch(newUserPassword(password))

  useEffect(() => {
    cleanAndSetNewJWTCache()
  }, [])

  const cleanAndSetNewJWTCache = async () => {
    persistor.purge()
    const queryParams = new URLSearchParams(window.location.search)
    const token = await queryParams.get('token')
    await TokenService.setJWT({ accessToken: token })
  }

  const handleChange = ({ target: { value, name } }) => {
    setInputs({ ...inputs, [name]: value })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    const resp = await sendNewUserPassword({ password: inputs.password })
    if (resp) {
      swalAlert.succes(intl.formatMessage({ id: 'swal.password-changed' }))
      await TokenService.removeJWT()
      persistor.purge()
      navigate(pathname.LOGIN)
    }
  }
  const footer = (
    <div className="info-password-panel">
      <hr />
      <p className="mt__05">
        <FormattedMessage id="suggestions" />:
      </p>
      <ul className="pl-2 ml-2 mt-0 line-height-3">
        <li>
          <FormattedMessage id="at.least.one.lowercase" />
        </li>
        <li>
          <FormattedMessage id="at.least.one.uppercase" />
        </li>
        <li>
          <FormattedMessage id="at.least.one.numeric" />
        </li>
        <li>
          <FormattedMessage id="minimum.8.characters" />
        </li>
      </ul>
    </div>
  )

  const validatePasswordFormat = () =>
    validators.passwordFormat(inputs.password)
  const validateConfirmPassword = () =>
    validators.equals(inputs.password, inputs.confirmPassword)

  return (
    <div className="new-user-password">
      <div className="new-password-box">
        <div className="new-password-form">
          <img className="login-box__img" src={logo} alt="gesMoure" />
          <div className="box-form">
            <h2 className="title-form">
              <FormattedMessage id="password.update" />
            </h2>
            <label className="new-user-label">
              {' '}
              <FormattedMessage id="password" />{' '}
            </label>
            <Password
              className="input-new-password"
              name="password"
              value={inputs.password}
              onChange={handleChange}
              toggleMask
              footer={footer}
              promptLabel={intl.formatMessage({ id: 'password.choose' })}
              weakLabel={intl.formatMessage({ id: 'insecure' })}
              mediumLabel={intl.formatMessage({ id: 'average.complexity' })}
              strongLabel={intl.formatMessage({ id: 'password.strong' })}
            />
            <label className="new-user-label">
              {' '}
              <FormattedMessage id="password.repeat" />{' '}
            </label>
            <Password
              className="input-new-password"
              name="confirmPassword"
              value={inputs.confirmPassword}
              onChange={handleChange}
              toggleMask
              feedback={false}
            />
            <Button
              id="submitReset"
              btnText={intl.formatMessage({ id: 'button.save.password' })}
              btnType="submit"
              btnClass="btn__with-bg-type-2"
              isDisabled={
                !(validatePasswordFormat() && validateConfirmPassword())
              }
              onHandleClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewUserPassword
